import { pickerStatuses } from "components/Pages/Inbox/Picker/models/enums";
import { PickerProjectI } from "components/Pages/Inbox/Picker/models/models";

export const calcProjectsQuantity = (
  projects: PickerProjectI[],
  searchTerm: string = "",
  statuses: string[]
) => {
  if (!projects?.length) return 0;

  const remaining = filterPickerProjects(projects, searchTerm, statuses);

  return remaining?.length;
};

export const filterPickerProjects = (
  projects: PickerProjectI[],
  searchTerm: string = "",
  statuses: string[]
) => {
  return projects.filter((project) => {
    const searchString = buildSearchString(project);
    const statusesArr = getPickerStatusesNumArrayFromStr(statuses);

    return (
      (!statuses?.length || statusesArr.includes(+project.Status)) &&
      (!searchTerm || searchString.includes(searchTerm.toLocaleLowerCase()))
    );
  });
};

export const buildSearchString = (project: PickerProjectI) => {
  return `${project.ProjectName} ${project.ClientEmail} ${project.PickerProjectID}`.toLocaleLowerCase();
};

export const sliceCurrentPage = (
  currentPage: number,
  desktopCondition: boolean,
  itemsPerPage: number
) => {
  const from = (currentPage - 1) * itemsPerPage;
  const to = (currentPage - 1) * itemsPerPage + itemsPerPage;

  return [desktopCondition ? from : 0, to];
};

export const getPickerStatusesNumArrayFromStr = (str: string[]) => {
  if (!str?.length) return str;
  const strArr = str.filter((v) => !!v);
  const res = strArr.map((val) => pickerStatuses[val]);

  return res;
};
